module.exports = __webpack_public_path__ + "static/media/veritas-screenshot-5.27feb4b9.png";